import React, { useEffect, useState } from "react";
import axios from "axios";
import AIGraphs from "./AIGraphs";
import InputPage from "./InputPage";
import { Container } from "@mui/material";
import { useDispatch } from "react-redux";
import { toastify } from "../toastify/toast";
import BackgroundVideoContainer from "../layouts/BackgroundVideo";
import { loadingAction, loadingBtnAction } from "../redux/actions/userActions";

const Home = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [showGraphs, setShowGraphs] = useState(false);

  useEffect(() => {
    dispatch(loadingAction(false));
    dispatch(loadingBtnAction(false));
  }, []);

  const onSubmitForm = async (data) => {
    dispatch(loadingAction(true));
    dispatch(loadingBtnAction(true));
    const email = data.email;
    const industry = data.industry;

    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    const formData = new FormData();

    formData.append("industry_type", industry);
    formData.append("email", email);

    try {
      const response = await axios.post(
        "https://aibooth.purelogics.net/api/businesses/predict_business_future/",
        formData
      );
      setData(response.data.data);
      setShowGraphs(true);
      dispatch(loadingAction(false));
      dispatch(loadingBtnAction(false));
    } catch (error) {
      toastify("error", error.response.data.message);
      dispatch(loadingAction(false));
      dispatch(loadingBtnAction(false));
    }
  };

  return (
    <BackgroundVideoContainer showGraphs={showGraphs}>
      <Container
        component={"main"}
        maxWidth="xl"
        sx={{ height: "80vh", px: "40px !important" }}
      >
        {showGraphs ? (
          <AIGraphs data={data} setShowGraphs={setShowGraphs} />
        ) : (
          <InputPage onSubmitForm={onSubmitForm} />
        )}
      </Container>
    </BackgroundVideoContainer>
  );
};

export default Home;
